import React, { memo, useMemo, useState, useEffect } from "react"

import { useApp } from "../../hooks/useApp"
import { useCustomerContext } from "../../hooks/useCustomer"

declare global {
  interface Window {
    userKlaviyo: any
  }
}

export const withHeader = Component =>
  memo(({ name = "Header", sticky, activeHeaderHero, fixed, location }: any) => {
    const {
      activeHover,
      setFilterScroll,
      // prevDirection, setprevDirection,
      globalStateReducer,
    } = useApp()

    const [{ activeMenu, activeCart, activeSearch, activeGuide }] = globalStateReducer

    const [position, setPosition] = useState(fixed)
    const [prevScroll, setprevScroll] = useState(0)
    const [direction, setDirection] = useState(0)
    const [prevDirection, setprevDirection] = useState(0)
    const [newclass, setNewClass] = useState("")

    let userData = {
      email: "anonymous@user.com",
      first_name: "Anonymous",
      last_name: "User",
    }
    const { customer } = useCustomerContext()
    if (customer) {
      userData = {
        email: customer.email,
        first_name: customer.firstName,
        last_name: customer.lastName,
      }
    }

    useEffect(() => {
      if (typeof window !== `undefined`) {
        const doc = document.documentElement
        const w = window
        let curScroll
        setprevScroll(w.scrollY || doc.scrollTop)
        window.onscroll = () => {
          curScroll = w.scrollY || doc.scrollTop
          if (curScroll > prevScroll) {
            //scrolled up
            setDirection(2)
          } else if (curScroll < prevScroll) {
            //scrolled down
            setDirection(1)
          }

          if (direction !== prevDirection) {
            toggleHeader(direction, curScroll)
          }

          if (curScroll === 0) {
            setNewClass("")
          }

          setprevScroll(curScroll)
          const filterTop = document.getElementById("searchSection")
          if (filterTop) {
            const height = filterTop.offsetTop
            stickyFilter(height)
          }
        }
      }
      window.userKlaviyo(userData)
      if (activeMenu || activeCart || activeSearch) {
        setPosition(true)
      } else {
        setPosition(false)
      }
    }, [activeMenu, activeCart, activeSearch, direction, prevDirection, prevScroll])

    const toggleHeader = function (direction, curScroll) {
      if (direction === 2 && curScroll > 52) {
        setNewClass("hideheader")
        setprevDirection(direction)
      } else if (direction === 1) {
        setNewClass("")
        setprevDirection(direction)
      }
    }
    const stickyFilter = height => {
      if (window.pageYOffset > height && prevDirection === 2) {
        setFilterScroll(true)
      } else {
        setFilterScroll(false)
      }
    }
    Component.displayName = name
    return useMemo(
      () => (
        <Component
          sticky={sticky}
          position={position}
          activeHeaderHero={activeHeaderHero}
          fixed={fixed}
          newclass={newclass}
          location={location}
          activeSearch={activeSearch}
          activeMenu={activeMenu}
          activeHover={activeHover}
          activeGuide={activeGuide}
          activeCart={activeCart}
        />
      ),
      [sticky, activeHeaderHero, fixed, newclass, activeCart, position, activeSearch, activeMenu, location, activeHover, activeGuide]
    )
  })
